module.exports = __webpack_public_path__ + "img/shengri_bg.8713987a.png";